// import Link from "next/link"
import { motion } from "framer-motion";
import SearchInput from "./SearchInput"


function WelcomePage() {
    return (<>
    
      <motion.div
      initial={{ y: 25, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{
        duration: 0.75,
      }}
      className="nav-bar"
    >
<div id="form" className="min-h-[300px] p-2 px-4 bg-white mt-3 rounded">
      <SearchInput/>
    </div>
    </motion.div>

    
    



  
   
    </>)
}
export default WelcomePage